import React from "react";
import BackgroundImg from "../Assets/Images/1h1.png";
import ProvideImg from "../Assets/Images/about.png";

const AboutSection = () => {
  return (
    <div
      className="sbs-what-riyaqas pd-default-120"
      style={{ backgroundImage: `url(${BackgroundImg})` }}
    >
      <div className="container">
        <div className="row">
          {/* Image Section */}
          <div
            className="col-lg-6 wow fadeInRight animated"
            data-wow-duration="1s"
            data-wow-delay="0.3s"
          >
            <img src={ProvideImg} alt="img" />
          </div>

          {/* Content Section */}
          <div className="col-xl-5 col-lg-6 desktop-center-item">
            <div
              className="desktop-center-area wow fadeInLeft animated"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <div className="section-title style-two">
                <h2 className="title">
                  What is <span>FusionHub?</span>
                </h2>
                <p> FusionHub is where innovation meets expertise.</p>
                <p>FusionHub is a multidisciplinary solutions provider based in USA, offering a broad spectrum of services including IT Solutions, Civil Engineering, Lighting Design, and many more. Since our inception, we have been committed to delivering innovative, efficient, and high quality solutions to clients across various industries, both locally and internationally.</p>
                <p> Our strength lies in our diverse team of professionals engineers, developers, designers, and consultants who work collaboratively to deliver customized services that meet the evolving needs of modern businesses and infrastructure projects.</p>
                <p> Whether it's building robust digital platforms, engineering sustainable structures, or designing impactful lighting systems,  FusionHub blends technology, creativity, and expertise to turn ideas into reality. </p>
                <p> We pride ourselves on our client focused approach, ensuring transparency, quality, and excellence at every step. </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
